export const CHANNEL_HANDLER_ID = "sendBirdMessageChannelHandler";
